<mat-slide-toggle [labelPosition]="labelPosition"
                  [color]="color"
                  (change)="change.emit($event)"
                  [formControl]="control"
>
  <ng-content select="[label]"></ng-content>
</mat-slide-toggle>
